'use strict';

/**
 * Displays a little widget that is essentially a password input form combined with a confirm button.
 */
customerZone.component('confirmWithPassword', {
    bindings: {
        confirm: '&',
        valid: '&',
        onError: '&'
    },
    templateUrl: customerZone.fromBase('components/confirm-with-password/confirm-with-password.component.html'),
    controller: ['$q', '$log', 'errorCode', 'utils', function($q, $log, errorCode, utils) {
        var vm = this;

        vm.incorrectPassword = false;

        vm.doConfirm = function () {
            vm.incorrectPassword = false;
            var result = vm.confirm({password: vm.password});
            return $q.when(result)
                .then(function(){
                    vm.password = '';
                    vm.incorrectPassword = undefined;
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.INVALID_CREDENTIALS)){
                        vm.incorrectPassword = vm.password;
                    }
                    else
                        handleError(error);
                });
        };

        var handleError = function(error){
            if (vm.onError) vm.onError({error: error});
            else {
                $log.error('confirm password', error);
                utils.showError();
            }
        };

        vm.checkValidity = function() {
            return !vm.valid || vm.valid({});
        };
    }],
    controllerAs: 'vm'
});
